export const fullAddress = (address) => {
  const street = [address.street1, address.apartment_number].filter(v => !!v).join(' ')
  return [street, address.city, address.region, address.zip_code].filter(v => !!v).join(', ')
}